let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("gWoEm"), load("2u53D"), load("kPKOV"), load("34R0T")]).then(() => parcelRequire('f2tcq'));